import { render, staticRenderFns } from "./addTestingCenter.vue?vue&type=template&id=5a0f3787&"
import script from "./addTestingCenter.vue?vue&type=script&lang=js&"
export * from "./addTestingCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports